import {
    InitialState,
    SailsTariffOverviewStorage,
} from 'Container/App/interface';
import { getAtomicId } from 'Container/App/helpers/getAtomicId';
import { getDeviceId } from 'Container/App/helpers/getDeviceId';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import {
    RedTariff,
    SAILS_BNT_STORAGE,
    YoungTariff,
} from '@vfde-sails/constants';
import { getInsurance } from 'Container/App/helpers/getInsurance';
import { getGigakombi } from 'Container/App/helpers/getGigakombi';
import { getSelectedSubscriptionId } from 'Container/App/helpers/getSelectedSubscriptionId';
import {
    getTauschbonus,
    getTradeIn,
} from 'Container/App/helpers/getTradeIn';
import { getRestlaufzeit } from 'Container/App/helpers/getRestlaufzeit';
import { getFlowType } from 'Container/App/helpers/getFlowType';
import { getRedPlusIds } from 'Container/App/helpers/getRedPlusIds';
import { getSalesChannel } from 'Container/App/helpers/getSalesChannel';
import getDefaultSubscriptionId from 'Container/App/helpers/getDefaultSubscriptionId';
import { OptionPicker } from '@vfde-brix/ws10/option-picker';
import { getCookie } from '@vfde-sails/utils';

const getCustomerConfig = (
    availableSubscriptionIds: (RedTariff | YoungTariff)[],
    optionPicker: OptionPicker | null,
): NonNullable<InitialState['customerConfig']> => {
    const storage = getSessionStorageItemJson<SailsTariffOverviewStorage | null>(SAILS_BNT_STORAGE);

    const salesChannel = getSalesChannel();
    const hasGigakombi = getGigakombi(salesChannel, storage);
    const selectedSubscriptionId = getSelectedSubscriptionId(storage, salesChannel, availableSubscriptionIds);

    return {
        salesChannel,
        selectedSubscriptionId,
        defaultSubscriptionId: (!selectedSubscriptionId && getDefaultSubscriptionId(optionPicker)) || null,
        hasGigakombi,
        insurance: getInsurance(storage),
        hasTradeIn: getTradeIn(storage),
        hasTauschbonus: getTauschbonus(storage),
        atomicId: getAtomicId(),
        deviceId: getDeviceId(storage),
        isRestlaufzeit: getRestlaufzeit(storage),
        flowType: getFlowType(storage),
        redplusIds: getRedPlusIds(storage),
        hasCashback: !!getCookie('adv_cb'),
    };
};

export default getCustomerConfig;
